import { loadEmblaCarousel } from '../util/load-dependencies';
import SiteEvents, { SiteEventNames } from '../util/site-events';
import EmblaAutoplay from '../util/embla/autoplay';
import EmblaPagination from '../util/embla/pagination';
import { enableNavButtons } from '../util/embla/util';

class BlockMedia {
	constructor(blockEl) {
		this.blockEl = blockEl;
		this.emblaRootEl = this.blockEl.querySelector('.embla');
		this.btnPrevEl = this.blockEl.querySelector('.block-media__nav-button--prev');
		this.btnNextEl = this.blockEl.querySelector('.block-media__nav-button--next');
		this.paginationEl = this.blockEl.querySelector('.block-media__pagination');
		this.emblaAutoplay = null;
		this.emblaPagination = null;

		this.transitionSpeed = this.emblaRootEl
			? parseInt(this.emblaRootEl.getAttribute('data-transition-speed') || 300, 10)
			: 300;

		this.enableAutoplay = this.emblaRootEl
			? parseInt(this.emblaRootEl.getAttribute('data-enable-autoplay') || 0, 10)
			: 0;

		this.autoplaySpeed = this.emblaRootEl
			? parseInt(this.emblaRootEl.getAttribute('data-autoplay-speed') || 3000, 10)
			: 3000;

		this.emblaInstance = null;

		const numSlides = Array.from(this.blockEl.querySelectorAll('.embla__slide')).length;

		if (numSlides > 1) {
			this.initEmbla();
		}
	}

	async initEmbla() {
		try {
			const EmblaCarousel = await loadEmblaCarousel();

			this.emblaInstance = EmblaCarousel(this.emblaRootEl, {
				loop: true,
				speed: this.transitionSpeed
			});

			if (this.emblaInstance) {
				this.emblaInstance.on('init', () => {
					SiteEvents.publish(SiteEventNames.IMAGEBUDDY_TRIGGER_UPDATE);
				});

				enableNavButtons(this.emblaInstance, [this.btnPrevEl], [this.btnNextEl]);

				this.emblaPagination = new EmblaPagination(this.emblaInstance, this.paginationEl, {
					buttonClassName: 'block-media__pagination-button'
				});

				if (this.enableAutoplay && this.autoplaySpeed) {
					this.emblaAutoplay = new EmblaAutoplay(this.emblaInstance, this.autoplaySpeed);
				}
			}
		} catch (err) {
			console.error(err);
		}
	}
}

export default BlockMedia;
